import { ref } from 'vue'

// Module-level singleton: the single AuroraBackground instance lives in
// App.vue (mounted once, behind every route), but the mic level it should
// react to comes from whichever view currently owns a recording session
// (only RecordView today, via useVoiceRecorder's per-instance state). These
// shared refs are the bridge between the two.
const level = ref(0)
const reactive = ref(false)

export function useAuroraReactivity() {
  return { level, reactive }
}
